import { useMutation, useQueryClient } from '@tanstack/react-query'

import { post } from '../apiClient'
import { type TerminateReservationBody } from '../../../common/validations/reservationSchema'
import {
  TerminateRecurringReservationResponse,
  TerminateRecurringReservationResponseSchema,
} from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export type TerminateReservationRequest = TerminateReservationBody

export const useAPITerminateRecurringReservation = (contractId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      request: TerminateReservationRequest
    ): Promise<TerminateRecurringReservationResponse> => {
      const response = await post(
        `/contracts/${contractId}/reservations/terminate`,
        request as unknown as Record<string, unknown>,
        TerminateRecurringReservationResponseSchema
      )
      return response
    },
    throwOnError: false,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['reservations', contractId],
      })

      queryClient.invalidateQueries({
        queryKey: [
          `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`,
        ],
      })

      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as string
          return (
            key?.includes(
              `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`
            ) && key?.includes('/time-slots')
          )
        },
      })
    },
  })
}
